import { doPost } from './common'

const serviceSlug = 'drag-and-drop'

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    stepType: 'drag-and-drop',
  }

  return doPost(`/${serviceSlug}/start`, payload)
}

export const complete = (breakId, stepId, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    skipped: stepSkipped,
  }

  return doPost(`/${serviceSlug}/complete`, payload)
}

export const submitMatchDrop = async ({ breakId, stepId, dragId, pairs }) => {
  console.log('here')
  let payload = {
    breakId,
    stepId,
    dragId,
    pairs,
  }

  return doPost(`/${serviceSlug}/submit`, payload)
}

export const submitOrder = ({ breakId, stepId, dragId, choices }) => {
  let payload = {
    breakId,
    stepId,
    dragId,
    choices,
    pairs: [],
  }

  return doPost(`/${serviceSlug}/submit`, payload)
}

export const submitRanking = ({ breakId, stepId, dragId, choices }) => {
  let payload = {
    breakId,
    stepId,
    dragId,
    choices,
    pairs: [],
  }

  return doPost(`/${serviceSlug}/submit`, payload)
}
